import { MealImpact } from '@/hooks/useExperimentResults';

export interface ValidationResult {
  isValid: boolean;
  reason?: string;
}
export const validateExperiment = (
  result: MealImpact, 
  isDiabetic: boolean
): ValidationResult => {
  if (result.start_glucose_level == null || result.start_glucose_level === undefined) {
    return {
      isValid: false,
      reason: 'Missing start glucose level data'
    };
  }

  const startGlucose = result.start_glucose_level;

  if (isDiabetic) {
    if (startGlucose < 70 || startGlucose > 130) {
      return {
        isValid: false,
        reason: `Start glucose level (${startGlucose} mg/dL) outside valid range for diabetic participants (70-130 mg/dL)`
      };
    }
  } else {
    if (startGlucose < 70 || startGlucose > 110) {
      return {
        isValid: false,
        reason: `Start glucose level (${startGlucose} mg/dL) outside valid range for non-diabetic participants (70-110 mg/dL)`
      };
    }
  }

  // If all checks pass, the experiment is valid
  return {
    isValid: true
  };
};
